export const UserRoles = {
  ADMIN: 'ADMIN',
  GATEKEEPER: 'GATEKEEPER',
  SUPERVISOR: 'SUPERVISOR',
  JUDGE: 'JUDGE',
} as const;

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];

export const ROLE_IDS: Record<UserRole, number> = {
  [UserRoles.ADMIN]: 1,
  [UserRoles.SUPERVISOR]: 2,
  [UserRoles.JUDGE]: 3,
  [UserRoles.GATEKEEPER]: 4,
};

export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  [UserRoles.ADMIN]: 'Admin',
  [UserRoles.GATEKEEPER]: 'Gatekeeper',
  [UserRoles.SUPERVISOR]: 'Supervisor',
  [UserRoles.JUDGE]: 'Judge',
};

export const PERMISSIONS: {
  CREATE_USERS: readonly UserRole[];
  DELETE_USERS: readonly UserRole[];
  UPDATE_ANY_USER: readonly UserRole[];
  CREATE_BATTLES: readonly UserRole[];
  DELETE_BATTLES: readonly UserRole[];
  UPDATE_ANY_BATTLE: readonly UserRole[];
  UPDATE_OWN_BATTLES: readonly UserRole[];
  JUDGE_BATTLES: readonly UserRole[];
  VIEW_BATTLES: readonly UserRole[];
  VIEW_USERS: readonly UserRole[];
  VIEW_JUDGE_IDENTITY: readonly UserRole[];
} = {

  CREATE_USERS: [UserRoles.ADMIN, UserRoles.GATEKEEPER] as readonly UserRole[],
  DELETE_USERS: [UserRoles.ADMIN] as readonly UserRole[],
  UPDATE_ANY_USER: [UserRoles.ADMIN] as readonly UserRole[],

  CREATE_BATTLES: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR] as readonly UserRole[],
  DELETE_BATTLES: [UserRoles.ADMIN] as readonly UserRole[],
  UPDATE_ANY_BATTLE: [UserRoles.ADMIN] as readonly UserRole[],
  UPDATE_OWN_BATTLES: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR] as readonly UserRole[],

  JUDGE_BATTLES: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR, UserRoles.JUDGE] as readonly UserRole[],

  VIEW_BATTLES: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR, UserRoles.JUDGE] as readonly UserRole[],
  VIEW_USERS: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR, UserRoles.JUDGE] as readonly UserRole[],

  // Judge identity (name) on verdict listings — supervisory roles reviewing
  // how judges voted. Judges themselves see an anonymized "Judge" label.
  VIEW_JUDGE_IDENTITY: [UserRoles.ADMIN, UserRoles.GATEKEEPER, UserRoles.SUPERVISOR] as readonly UserRole[],
};

